import { ApplicationRoutePaths } from "@shared-core/routes/application-route-paths";

export abstract class StockExpirationSettingsRoutePaths extends ApplicationRoutePaths {
  static override readonly ROOT = "stock-expiration-settings";
}
